import { encrypt } from '../../../../utils/cipher';
import axios from 'axios';
import { ls } from '../../../../variables';
import { useStateValue } from '../../../../Hooks/stateProvider';
import { errorHandler } from '../../../../utils/errorHandling';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import UploadAction from '../../../CommonLayouts/UploadAction';

const AlertFinalSubmission = ({ payload, openModal, setOpenModal, handlePreviewClick }) => {
  const [{ fileName, fileDetails }, dispatch] = useStateValue();
  const navigate = useNavigate();
  const formData = new FormData();


  const handleSubmit = async () => {
    const encryptedFormData = await encrypt(payload);
    formData.append("file", fileDetails);
    formData.append("fileName", fileName);
    formData.append("payload", encryptedFormData);
    const encryptedHeaders = await encrypt({
      authtoken: ls.get("authToken"),
      refreshtoken: ls.get("refreshToken"),
    });
    dispatch({ type: "SHOW_LOADER" });
    axios
      .post("/api/pms/trackerFinalSubmit", formData, {
        withCredentials: true,
        headers: {
          headers: encryptedHeaders,
        }
      })
      .then((receivedStatus) => {
        if (receivedStatus.data.message == "success") {
          dispatch({ type: "HIDE_LOADER" });
          handlePreviewClick();
          setOpenModal(false);
        }
      })
      .catch((err) => {
        errorHandler(err, navigate)
      })
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          maxHeight: "fit-content",
          overflowY: "auto",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        {/* <span>Comments</span> */}
        {/* <div className="closeIcon" onClick={() => setOpenModal(false)}>
      <CloseIcon
        sx={{ cursor: "pointer", "&:hover": { color: "#ff0000" } }}
      />
    </div> */}
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "100%",
              margin: 0,
              padding: ".8em 1em 0",
              color: "inherit",
              fontSize: "1.875em",
              fontWeight: 600,
              textAlign: "center",
              textTransform: "none",
              wordWrap: "break-word",
            }}
          >
            Are you sure about your submission?
          </div>
          <h3
            style={{
              zIndex: 1,
              justifyContent: "center",
              margin: "1em 1.6em .3em",
              padding: 0,
              overflow: "auto",
              color: "inherit",
              fontSize: "1.125em",
              fontWeight: "normal",
              lineHeight: "normal",
              textAlign: "center",
              wordWrap: "break-word",
              wordBreak: "break-word",
            }}
          >
            Responses once recorded, shall not be reverted later.
          </h3>
        </div>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
          padding: "1rem",
        }}
      >
        <UploadAction />
        <button
          style={{
            border: 0,
            borderRadius: ".25em",
            background: "initial",
            backgroundColor: "#154063",
            color: "#fff",
            fontSize: "1em",
            width: "8.125rem",
            height: "1.875rem",
            cursor: "pointer"
          }}
          onClick={handleSubmit}
        >
          Submit
        </button>
        <button
          style={{
            border: 0,
            borderRadius: ".25em",
            background: "initial",
            backgroundColor: "#d33",
            color: "#fff",
            fontSize: "1em",
            width: "8.125rem",
            height: "1.875rem",
            cursor: "pointer"
          }}
          onClick={() => setOpenModal(false)}
        >
          Cancel
        </button>
      </DialogActions>
    </Dialog>

  )
}

export default AlertFinalSubmission